import { Button } from 'components/Button'
import { useModals } from 'almanac-ui/Modal'
import { LocationModal, Location } from 'components/Wizards/RetryWizard/LocationModal'
import { AlmanacFile, GeneratePrompt } from 'types'

interface Props {
  onSubmit: (
    additionalPayload: Partial<
      GeneratePrompt & { filename?: string; project?: AlmanacFile; articleId?: string | null }
    >,
  ) => void
  project: AlmanacFile
  isDisabled: boolean
}

export const GenerateNewDocButton = ({ onSubmit, project, isDisabled }: Props) => {
  const { openModal, closeModal } = useModals()

  const handlePress = () => {
    openModal(
      LocationModal,
      {
        onConfirm: (location: Location) => onSubmit({ ...location, articleId: null }),
        onCancel: closeModal,
        project,
      },
      { newStack: true },
    )
  }

  return (
    <Button size="lg" variant="tertiary" onPress={handlePress} isDisabled={isDisabled}>
      Generate New Doc
    </Button>
  )
}
